import React from "react";
import _ from "lodash";
import SchemaConfigTable from "components/common/SchemaConfigTable";
import { notify } from "react-notify-toast";
import { getSection, SECTION_CATEGORY } from "../../constants/AutoPilotConfig";

class AutoPilotConfig extends React.PureComponent {
  constructor(props) {
    super(props);

    const sections = getSection();
    this.state = {
      // activeTab: configSections[0].sectionKey, // SYSTEM
      activeTab: SECTION_CATEGORY.PROPHET, // PROPHET
      sections: _.orderBy(sections, "indexOrder", "asc"),
    };

    this.onTabSelected = this.onTabSelected.bind(this);
  }

  onTabSelected(tab) {
    if (this.state.activeTab === tab) return;
    this.setState({ activeTab: tab });
  }

  render() {
    const {
      unitId,
      networkId,
      schemasGroupedBySection,
      isEditing,
      handleStartEditMode,
      handleCancelEditMode,
      handleApplyChanges,
      newConfig,
      isHintConfig,
    } = this.props;
    const { activeTab, sections } = this.state;

    if (!schemasGroupedBySection) {
      return "";
    }

    const filteredSection = isHintConfig
      ? _.filter(sections, { sectionKey: "prophet" })
      : sections;

    return (
      <>
        <div className="flex px-4">
          {/* {isHintConfig && (
            <div className="bg-orange-200 px-6 py-3 rounded mx-4 -ml-2 my-4">
              <div className="font-bold text-lg text-gray-700">
                Basic Settings
              </div>
              <div className="text-gray-800 text-sm">
                If you can't find what you're looking for, switch to{" "}
                <span
                  className="cursor-pointer font-bold text-blue-500 hover:underline"
                  onClick={handleShowAdvancedSettings}
                >
                  advanced settings
                </span>{" "}
                for more detailed configurations.
              </div>
            </div>
          )} */}

          {!isHintConfig &&
            filteredSection.map((s) => {
              const isActive = activeTab === s.sectionKey;

              return (
                <div
                  key={s.sectionKey}
                  className={`px-4 py-2 font-semibold ${
                    isActive ? "border-b-2 border-blue-400" : "text-gray-600"
                  } ${
                    isEditing
                      ? isActive
                        ? ""
                        : "cursor-not-allowed"
                      : "cursor-pointer hover:text-black"
                  }`}
                  onClick={() => {
                    if (isEditing) {
                      notify.show(
                        "Apply changes before moving on to the next section.",
                        "warning",
                        3000
                      );
                      return;
                    }
                    return this.onTabSelected(s.sectionKey);
                  }}
                >
                  {s.sectionTitle}
                </div>
              );
            })}
        </div>

        <div>
          {filteredSection.map((s) => {
            const isCurrentTab = activeTab === s.sectionKey;
            const configSchemas = _.get(schemasGroupedBySection, [
              s.sectionKey,
              "configSchemas",
            ]);

            if (isCurrentTab) {
              return (
                <React.Fragment key={s.sectionKey}>
                  <div className="mb-3 px-8 pt-4">
                    <div className="text-2xl font-extrabold leading-tight text-gray-800">
                      {s.title}
                    </div>
                  </div>

                  <div className="pr-8">
                    <SchemaConfigTable
                      networkId={networkId}
                      unitId={unitId}
                      configSchemas={configSchemas}
                      newConfig={newConfig}
                      handleApplyChanges={(params) =>
                        handleApplyChanges({
                          ...params,
                          sectionConfigKey: s.sectionConfigKey,
                        })
                      }
                      handleStartEditMode={handleStartEditMode}
                      handleCancelEditMode={handleCancelEditMode}
                    ></SchemaConfigTable>
                  </div>
                </React.Fragment>
              );
            } else {
              return "";
            }
          })}
        </div>
      </>
    );
  }
}

export default AutoPilotConfig;
